import { useCallback, useState } from "react";
import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { I18nMarkup, useI18nContext } from "@hopper-b2b/i18n";
import {
  ActionLink,
  ButtonWrap,
  IconComponent,
  IconName,
  MobilePopoverCard,
} from "@hopper-b2b/ui";
import { getEnvVariables, openExternalLink } from "@hopper-b2b/utilities";

import "./styles.scss";

export interface ITermsOfServiceBlock {
  clientAssets?: Record<string, any>;
}

export const TermsOfServiceBlock = (props: ITermsOfServiceBlock) => {
  const { t, brand } = useI18nContext();
  const { clientAssets } = props;

  const [openPopover, setOpenPopover] = useState(false);

  const redirect = useCallback(() => {
    if (brand?.urls?.priceFreezeTerms) {
      openExternalLink(brand.urls.priceFreezeTerms);
    }
  }, [brand]);

  return (
    <>
      <div
        className="price-freeze-tos icon-card-container"
        onClick={() => setOpenPopover(true)}
      >
        <div className="price-freeze-tos-icon icon-card-icon">
          {clientAssets && clientAssets["info"] ? (
            // eslint-disable-next-line jsx-a11y/alt-text
            <img className="mobile-left-icon" src={clientAssets["info"]} />
          ) : (
            <IconComponent
              className="mobile-left-icon"
              name={IconName.InfoCircleFill}
            />
          )}
        </div>
        <div className="price-freeze-tos-info icon-card-details">
          <div className="price-freeze-tos-title">
            {t("priceFreezePurchase.termsOfService.cta")}
          </div>
          <div className="price-freeze-tos-chevron">
            {clientAssets && clientAssets["chevron"] ? (
              // eslint-disable-next-line jsx-a11y/alt-text
              <img className="mobile-left-icon" src={clientAssets["chevron"]} />
            ) : (
              <FontAwesomeIcon
                className="mobile-right-chevron"
                icon={faChevronRight as IconProp}
              />
            )}
          </div>
        </div>
      </div>
      <MobilePopoverCard
        open={openPopover}
        className={"checkout-popover price-freeze-tos-checkout-popover"}
        headerElement={
          <>
            <h4>
              {t("priceFreezePurchase.termsOfService.termsAndConditions")}
            </h4>
            <ActionLink
              className="filter-close-button"
              content={
                <IconComponent
                  ariaLabel={t("modalClose.ariaLabel")}
                  className={"close-button-icon"}
                  name={IconName.Close}
                />
              }
              label={t("modalClose.label")}
              onClick={() => setOpenPopover(false)}
            />
          </>
        }
      >
        <div className="price-freeze-tos-popover-container">
          <div className="price-freeze-tos-container">
            <div className="price-freeze-tos-title">
              {t("priceFreezePurchase.termsOfService.termsTitle")}
            </div>
            <div className="price-freeze-tos-body">
              <I18nMarkup
                tKey={"priceFreezePurchase.termsOfService.termsText"}
              />
              {getEnvVariables("clientName") === "uber" ? (
                <ButtonWrap
                  className="price-freeze-tos-link"
                  onClick={redirect}
                >
                  {t("termsLink")}.
                </ButtonWrap>
              ) : null}
            </div>
          </div>
        </div>
      </MobilePopoverCard>
    </>
  );
};
